import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import CancelIcon from '@mui/icons-material/Cancel';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import { Box, IconButton, InputAdornment, TextField } from '@mui/material';
import Grid from "@mui/material/Grid2"
import { parseMoneyInput } from '../../Utils';


export default function InputModal({
    open,
    label,
    callback,
    title = "Submit",
    defaultInput = "",
    maxWidth = "sm",
    multiline = false,
    isMoney = false,
    minRows = 2,
    acceptEmpty = true,
}) {
    const [input, setInput] = React.useState(defaultInput)

    const updateInput = (e) => {
        if (isMoney) {
            setInput(parseMoneyInput(input, e.target.value, { allow_empty: true }))
        } else {
            setInput(e.target.value)
        }
    }

    React.useEffect(() => {
        setInput(defaultInput)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])

    const call_callback = (value) => {
        setInput(defaultInput)
        callback && callback(value, input)
    }

    return (
        (<div>
            <Dialog
                open={open}
                onClose={() => callback && callback(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                maxWidth={maxWidth}
                fullWidth={true}
            >
                <DialogTitle>
                    <span style={{ "paddingRight": "24px" }}>{title}</span>
                    <IconButton
                        aria-label="close"
                        onClick={() => callback && callback(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ minWidth: '300px' }}>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="input"
                            label={label}
                            type="text"
                            fullWidth
                            variant="filled"
                            value={input}
                            onChange={updateInput}
                            multiline={multiline}
                            minRows={minRows}
                            slotProps={{
                                input: {
                                    startAdornment: isMoney && <InputAdornment position="start">
                                        {<AttachMoneyIcon />}
                                    </InputAdornment>,
                                },
                            }}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Grid container justifyContent="space-between" sx={{ padding: "0px 10px 10px 10px" }} spacing={2}>
                        <Grid size="auto">
                            <Button variant='outlined' color='error' onClick={() => call_callback(false)}>
                                <CancelIcon /> <Box sx={{ pl: 1 }}><span>Cancel</span></Box>
                            </Button>
                        </Grid>
                        <Grid size="auto">
                            <Button variant="contained" autoFocus onClick={() => call_callback(true)} disabled={(isMoney && input === "") || (!acceptEmpty && input === "")}>
                                <CheckIcon /> <Box sx={{ pl: 1 }}><span>Submit</span></Box>
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </div>)
    );
}